import React from 'react';
import loadable from '@loadable/component';
import { CLASS_DETAIL_ROUTE } from './ClassDetail.route.path';

const InventoryDetail = loadable(() => import('features/InventoryDetail/InventoryDetailContainer'));

export default () => ({
  path: `${CLASS_DETAIL_ROUTE}/:venueAlias`,
  indexRoute: {
    component: props => <InventoryDetail {...props} />,
  },
  childRoutes: [
    {
      path: ':classAlias',
      component: props => <InventoryDetail {...props} />,
    },
    {
      path: ':classAlias/reviews',
      onEnter: ({ params }, replace, cb) =>
        cb(
          replace({
            pathname: `${CLASS_DETAIL_ROUTE}/${params.venueAlias}/${params.classAlias}#reviews`,
            state: { status: 301 },
          })
        ),
    },
    {
      path: ':classAlias/:scheduleId(\\d+)',
      component: props => <InventoryDetail {...props} />,
    },
  ],
});
